import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatBadge } from '@angular/material/badge';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-filter-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatBadge],
  templateUrl: './filter-button.component.html',
  styleUrl: './filter-button.component.scss',
})
export class FilterButtonComponent {
  @Input() badge: number | null = null;
  @Input() disabled: boolean = false;
  @Input() label: string | null;
}
